<template>
    <div class="marquee">
        <div class="marquee__content">
            <span style="font-weight: bold;">Call now, 2026 spots are filling fast! Reserve yours today!</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MarqueeText',
    data(){
        return{
            marqueeEnabled: true
        }
    }
}
</script>

<style>
.marquee {
    background-color: #212121;
    padding: 1rem;
}

.marquee__content {
    display: inline-block;
    color: white;
    font-size: 1.5rem;
    font-family: 'Roboto', sans-serif;
    animation: pulse 2s infinite;
}

@keyframes pulse {
    0% { transform: scale(1); opacity: 1; }
    50% { transform: scale(1.1); opacity: 0.5; }
    100% { transform: scale(1); opacity: 1; }
}
</style>